// src/app/theme.js - JavaScript version (no TypeScript)
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  spacing: 6,
  shape: {
    borderRadius: 4,
  },
  palette: {
    primary: {
      main: '#1A1B25',
      dark: '#0A2A2E',
      light: '#2F5E64',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#0EA5E9',
      contrastText: '#FFFFFF',
    },
    success: {
      main: '#22C55E',
      dark: '#16A34A',
    },
    warning: {
      main: '#F59E0B',
    },
    error: {
      main: '#EF4444',
    },
    info: {
      main: '#1570EF',
    },
    divider: '#E7EBF0',
    text: {
      primary: '#111827',
      secondary: '#475467',
    },
    background: {
      root: '#F7F9FC',
      default: '#F7F9FC',
      paper: '#FFFFFF',
      grid: '#FFFFFF',
    },
  },
  typography: {
    fontFamily:
      'Inter Tight, Work Sans, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
    h1: { fontWeight: 700, fontSize: '2.5rem', lineHeight: 1.2 },
    h2: { fontWeight: 600, fontSize: '1.6rem', lineHeight: 1.3 },
    h3: { fontWeight: 600, fontSize: '1.4rem', lineHeight: 1.25 },
    h4: { fontWeight: 600, fontSize: '1.2rem', lineHeight: 1.2 },
    h5: { fontWeight: 500, fontSize: '1rem', lineHeight: 1.2 },
    h6: { fontWeight: 500, fontSize: '0.95rem', lineHeight: 1.25 },
    body1: { fontSize: '1rem', lineHeight: 1.65 },
    body2: { fontSize: '0.95rem', lineHeight: 1.55 },
    button: { fontWeight: 600, textTransform: 'none', letterSpacing: '0.01em' },
  },
  breakpoints: {
    values: {
      xs: 0,
      tinyMobile: 355,
      sm: 600,
      mobile: 768,
      md: 900,
      tablet: 1024,
      desktop: 1280,
      lg: 1200,
      xl: 1536,
    },
  },
  components: {
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          borderColor: '#E7EBF0',
        },
      },
    },
    MuiCard: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: {
          border: '1px solid #E7EBF0',
          borderRadius: 12,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          height: '22px',
          borderRadius: '6px',
          fontSize: '0.75rem',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: '#092E3A',
          boxShadow: 'none',
          color: '#fff',
          borderRadius: '4px',
          padding: '6px 16px',
          '&:hover': {
            backgroundColor: '#0A3946',
            boxShadow: 'none',
          },
        },
      },
      variants: [
        {
          props: { variant: 'outlinedCustom' },
          style: {
            border: '1px solid rgba(0, 0, 0, 0.23)',
            borderRadius: '12px',
            backgroundColor: 'rgba(0, 0, 0, 0)',
            padding: '6px 16px',
            color: 'rgba(0, 0, 0, 0.87)',
            textTransform: 'none',
            fontWeight: 500,
            boxShadow: 'none',
            '&:hover': {
              backgroundColor: 'rgba(2, 8, 23, 0.04)',
              borderColor: 'rgba(2, 8, 23, 0.18)',
            },
          },
        },
      ],
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          height: 3,
          borderRadius: 3,
          backgroundColor: '#0E3A3F',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          color: '#667085',
          '&.Mui-selected': { color: '#111827' },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          borderRadius: '12px',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          '& .MuiOutlinedInput-notchedOutline': {
            borderRadius: 12,
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderRadius: 12,
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderRadius: 12,
          },
        },
        notchedOutline: {
          borderRadius: 12,
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          padding: 4,
          '&:hover': {
            backgroundColor: 'rgba(0,0,0,0.04)',
          },
          '&.Mui-checked': {
            color: '#1A1B25',
          },
          '& .MuiSvgIcon-root': {
            borderRadius: 12,
          },
        },
      },
    },
  },
});

export default theme;
